import React from 'react';
import { ehrByName } from 'pages/InsuranceBillingOnboarding/constants';
import s from './s.module.less';

type Props = {
    ehrName: string;
    size?: number;
};

const EhrBadge = ({ ehrName, size }: Props) => {
    const meta = ehrByName(ehrName);
    const sizeStyle = size ? { width: size, height: size, minWidth: size, fontSize: size < 34 ? 11 : 13 } : undefined;
    return (
        <div
            className={s.ehrBadge}
            style={{ background: `${meta.color}1f`, color: meta.color, ...sizeStyle }}
        >
            {meta.abbr}
        </div>
    );
};

export default EhrBadge;
